import React from 'react';
import ErpTablePage from '../components/ErpTablePage';

const DepreciationSchedule = () => {
  return <ErpTablePage moduleKey="depreciation_schedule" />;
};

export default DepreciationSchedule;